// 13,14,15 added for compatibility cases in order of conversion v2020 -> v2021
export type BeiEinkunftenAusEnum = '1' | '2' | '3' | '13' | '14' | '15';

export const BeiEinkunftenAusEnum = {
    _1: '1' as BeiEinkunftenAusEnum,
    _2: '2' as BeiEinkunftenAusEnum,
    _3: '3' as BeiEinkunftenAusEnum
};

